var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeiculosOficinaExterna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5L5.1 11.3C5.4 10.5 6.1 10 6.9 10H12.6C13.4 10 14.1 10.5 14.4 11.3L16 15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5H17V18C17 18.55 16.55 19 16 19H3.5C2.95 19 2.5 18.55 2.5 18V15.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21C7.1 21 8 20.1 8 19H4C4 20.1 4.9 21 6 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21C14.6 21 15.5 20.1 15.5 19H11.5C11.5 20.1 12.4 21 13.5 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.5C16.57 2.5 15 4.07 15 6C15 8.6 18.5 12.3 18.5 12.3C18.5 12.3 22 8.6 22 6C22 4.07 20.43 2.5 18.5 2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.1C19.11 7.1 19.6 6.61 19.6 6C19.6 5.39 19.11 4.9 18.5 4.9C17.89 4.9 17.4 5.39 17.4 6C17.4 6.61 17.89 7.1 18.5 7.1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeiculosOficinaExterna);
export default __webpack_public_path__ + "static/media/veiculos-oficina-externa.43ebefef12770415c5b7d8c8e7b0e73e.svg";
export { ForwardRef as ReactComponent };